<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">杠杆交易</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>杠杆列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
      </div>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';

export default {
  name: 'kpiProject',
  data() {
    return {
      updated: ''
    };
  },
  components: {
    List,
    Create
    // AddIn
  },
  computed: {
    ...mapState('lever', ['pagination'])
  },
  methods: {
    ...mapActions('lever', [
      'getList',
      'listAllCoin',
      'freshData',
      'getIdamount'
    ]),
    getProjectList(data = {}) {
      this.getList({
        ...data
      });
    },
    update() {
      this.freshData({ target: this.updated }).then(() => {
        this.updated = '';
      });
    }
  },
  created() {
    this.getProjectList();
    this.listAllCoin();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
